interface IMapper<T> {
	toDomain(): T | T[];
}

export abstract class Mapper<T> implements IMapper<T> {
	toDomain(): T | T[] {
		throw new Error('Method not implemented.');
	}
}
